/**
 * Created by huangxiao3 on 2017/6/8.
 */
import React,{Component} from 'react';
import {Icon} from 'jcloudui';
import styles from './styles.css';
import ApiClient from '../../apiClient/ApiClient';
export default class Customer extends Component {
  constructor(props, content) {
    super(props, content);
    this.state = {
      scrollTop: 0,
      // 反馈url
      feedbackUrl: '',
      // 购物车url
      cartUrl:'',
      // 购物车数量
      shopNum:0,
      weixinCodeUrl: '',
      weixinDisplay: '',
      appDownCodeUrl: '',
      appDownDisplay: '',
    };
  }
  componentWillMount() {
    var client = new ApiClient();
    // 获取购物车数量
    client.get('cart/mall/cart/queryCartItemNum').then(rs => {
      if (rs.code == 0) {
        this.setState({
          shopNum: rs.data
        });
      }
    });
    // 获取二维码
    client.get('/platform-service/mall/mobileconfig/queryAppDownUrlById').then(rs => {
      if (rs.code == 0) {
        this.setState({
          weixinCodeUrl: rs.data.weixinCodeUrl,
          weixinDisplay: rs.data.weixinDisplay,
          appDownCodeUrl: rs.data.appDownCodeUrl,
          appDownDisplay: rs.data.appDownDisplay,
        });
      }
    });
    // 域名
    client.get('/passport/logout')
      .then(
        (res) => {
          if(res.code == 0 && res.data) {
            res.data.map(_item => {
              if (_item.domainType == 1) {
                let feedbackUrl = `//${_item.domain}/website-view/user-feedback`;
                let cartUrl = `//${_item.domain}/website-view/cart`;
                this.setState({feedbackUrl: feedbackUrl, cartUrl: cartUrl});
              }
            });
          }
        },
        (err) => {
        }
      );
  }

  componentDidMount() {
    document.addEventListener('scroll', ()=>this.onChange(), true);
  }
  toTop() {
    document.body.scrollTop = 0;
  }
  onChange() {
    this.setState({scrollTop: document.body.scrollTop});
  }
  handleCreateShangQiao() {
    let defaultUrl = 'http://p.qiao.baidu.com/cps/chat?siteId=11653509&userId=5784152';
    var iWidth = 580;
    var iHeight = 510;
    var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
    let sqUrl = this.props.SqCode?this.props.SqCode:defaultUrl;
    window.open (sqUrl, "shangqiao", `height=510, width=580, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no, top=${iTop},left=${iLeft}`);
  }

  render() {
    return(
      <div className="customerreact">
        <div className="m-fixedbar">
          <div className="fixedbar-bd">
            <div className="fixedbar-item">
              <a className="sidecart" href={this.state.cartUrl} target="_blank">
                {this.state.shopNum != 0 ? <span className="goods-num">{this.state.shopNum}</span> : ''}
                <Icon type="anticon anticon-new-icon83"/><span className="fixedbar-text">进货车</span>
              </a>
            </div>
            <div className="fixedbar-item js-qrcode">
              <a href="javascript:" target="_blank"><Icon type="new-phone iconSize"/><span className="fixedbar-text">扫码优惠</span></a>
              <div className="hnc-mobile-pop hnc-mobile-pop-right">
                  <span className="arrow-rig">
                      <span className="right"></span>
                  </span>
                <div className="mobile-pop-item f-cb item-wx">
                  <div className="mobile_pop_qrcode">
                    <img src={this.state.weixinCodeUrl} width="80" height="80" />
                  </div>
                  <div className="mobile_pop_info">
                    <p>微信扫一扫</p>
                    <p>关注华南城网</p>
                    <p>微信商城</p>
                  </div>
                </div>
                <div className="mobile-pop-item f-cb item-app">
                  <div className="mobile_pop_qrcode">
                    <img src={this.state.appDownCodeUrl} width="80" height="80" />
                  </div>
                  <div className="mobile_pop_info">
                    <p>扫描二维码</p>
                    <p>立即下载APP</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="fixedbar-item js-kefu-item" onClick={::this.handleCreateShangQiao}>
              <a href="javascript:" target="_blank"><Icon type='anticon anticon-new-icon86'/><span className="fixedbar-text">联系客服</span></a>
            </div>
            <div className="fixedbar-item">
              <a href={this.state.feedbackUrl} target="_blank"><Icon type='anticon anticon-new-icon84'/><span className="fixedbar-text">反馈</span></a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
